
import api from "@/api/index"; //ABP API接口
import { Vue, Component } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";
import ElTableColumnCopy from "@/components/ElTableColumnCopy/index.vue";
import { MessageBox } from "element-ui";

import {
  CmsCategoryDto,
  CmsContentDto,
  CmsContentStatus,
  Int32EntityDto,
  OrganizationUnitDto,
  SwiperDto
} from "@/api/appService";

@Component({
  name: "CmsContentList",
  components: {ElTableColumnCopy}
})
export default class CmsContentList extends ElementTableView {
  tableItems: CmsContentDto[] = [];
  categories: CmsCategoryDto[] = [];
  currentOu:any = {};

  async created() {
    this.currentOu = this.$store.getters['user/ou'] as OrganizationUnitDto;
    await api.cmsCategory.getAll().then(res => {
      this.categories = res.items!;
    });
    await this.fetchData();
  }

  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    await api.cmsContent
      .getAll({
        categoryId: this.queryForm.categoryId,
        title: this.queryForm.keyword,
        status: this.queryForm.status,
        sorting: this.table.sorting,
        skipCount: this.skipCount,
        maxResultCount: this.table.pagesize
      })
      .then(res => {
        console.log(res);
        this.table.listLoading = false;
        this.tableItems = res.items!;
        this.table.totalCount = res.totalCount!;
      });
  }

  formatCreationTime(row: any) {
    return row.creationTime.substr(0, 19).replace("T", " ");
  }

  // 新建
  handleCreate() {
    this.$router.push({ path: "/cms/createCmsContent" });
  }
  private async handlePublish(index: number, row: any) {
    const body = { id: row.id };
    await api.cmsContent.publish({ body: body }).then(res => {
      this.$message({
        type: "success",
        message: "发布完成!"
      });
      this.fetchData();
    });
  }

  private async handleCancelPublish(index: number, row: any) {
    const body = { id: row.id };
    await api.cmsContent.cancelPublish({ body }).then(res => {
      this.$message({
        type: "success",
        message: "已取消发布!"
      });
      this.fetchData();
    });
  }

  // 编辑
  handleEdit(index: number, row: any) {
    const { id } = row;
    this.$router.push({
      path: `/cms/editContent/${id}`
    });
  }

  // 删除
  async handleDelete(index: number, row: CmsContentDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.cmsContent
        .delete({
          id: row.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.fetchData();
        });
    });
  }

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // Table排序
  async sort(e: any) {
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      keyword: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    };
    await this.fetchData();
  }

  async handelOnSaved() {
    await this.fetchData();
  }

  async handleSync(row:SwiperDto){
    this.$confirm('您确认要同步吗','提示').then(async ()=>{
      await api.cmsContent.sync({body:{id:row.id}}).then(res=>{
        this.$message({type:'success',message:'同步完成!'});
      })
    });
    ;
  }
}
